// The stage's line to the show engine, for things the room reacts to (Zed's voice → lights, music ducking).
// In the editor's preview the engine sits behind the front door; at a show it's on this machine.
export const engineUrl = () => {
    const override = new URLSearchParams(window.location.search).get('engine');
    if (override) return override;
    if (window.location.port === '4568') return `ws://${window.location.host}/engine-ws`;
    return 'ws://localhost:7300';
};

// The engine's HTTP side (media, show): behind the front door in the preview, on this machine at a show.
export const engineHttp = () => {
    const override = new URLSearchParams(window.location.search).get('engineHttp');
    if (override) return override;
    return window.location.port === '4568' ? '/engine' : 'http://localhost:7300';
};

let ws = null, retry = null;
const listeners = new Set();
// The beat is announced once, when its music starts; a scene that mounts a moment later (the title logo) still needs it.
let currentBeat = null;
const remember = (e) => {
    if (e.type === 'beat') currentBeat = e;
    else if (e.type === 'block-playback' && e.state !== 'playing' && currentBeat && e.block === currentBeat.block) currentBeat = null;
};

const connect = () => {
    if (ws || retry) return;
    try { ws = new WebSocket(engineUrl()); } catch (e) { ws = null; return; }
    ws.onclose = () => { ws = null; retry = setTimeout(() => { retry = null; connect(); }, 3000); };
    ws.onerror = () => {};
    ws.onmessage = (m) => {
        let d; try { d = JSON.parse(m.data); } catch (e) { return; }
        // a page that connects mid-show learns where the show is and what the stage should be showing
        if (d.type === 'snapshot' && d.state && d.state.scene) listeners.forEach(fn => fn({type: 'scene', index: d.state.sceneIndex, scene: d.state.scene}));
        if (d.type === 'snapshot' && d.state && d.state.stageVideo) listeners.forEach(fn => fn({type: 'stage-video', ...d.state.stageVideo}));
        if (d.type === 'snapshot' && d.state && d.state.beat) { remember(d.state.beat); listeners.forEach(fn => fn(d.state.beat)); }
        if (d.type !== 'event') return;
        remember(d.event);
        listeners.forEach(fn => fn(d.event));
    };
};

export const engineConnected = () => { connect(); return !!ws && ws.readyState === WebSocket.OPEN; };

// Every engine bus event, until the returned function is called.
export const onEngineEvent = (fn) => {
    connect();
    listeners.add(fn);
    if (currentBeat) fn(currentBeat);
    return () => listeners.delete(fn);
};

// Fire and forget: levels are only worth anything live, so nothing is queued while disconnected.
export const sendToEngine = (cmd) => {
    connect();
    if (ws && ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify(cmd));
};
